export default {

    userMenu: '/lx/manage/purview/menu',
    getCategoryList: '/lx/api/category/lxPage/list',
    getDocumentList: '/lx/api/doc/lxPage/list',
    getCityList: '/lx/api/city/list',
    createBusiness: '/lx/api/business/create',
    getBusinessInfo: (id) => `/lx/api/business/get/${id}`,
    createDocument: '/lx/api/document/task/create/unPublished',
    editBusiness: '/lx/api/business/edit',
    getAllcomList: (userId, page) => `/lx/api/business/list/${userId}?pageNum=${page}&pageSize=7`,
    getAllcom: (page, search, startTime, endTime) => `/lx/api/business/all?userId=gen&pageNum=${page}&pageSize=10&search=${search}&startTime=${startTime}&endTime=${endTime}`,
    getAllcommore: (search, startTime, endTime) => `/lx/api/business/new/list?userId=gen&search=${search}&startTime=${startTime}&endTime=${endTime}`,
    getBusinessTypeList: '/lx/card/business/btlist',
    getElevatorSeriesList: '/lx/archive/elevator-type/list',//系列
    getElevatorTypeList: '/lx/archive/elevator/whereList',//型号
    getDocumentTaskList: (id) => `/lx/api/document/task/get/${id}`,
    createProject: (id) => `/lx/api/document/task/create/project/${id}`,
    getSceneList: '/lx/card/scene/list',
    getSecenDocList: (id) => `/lx/card/scene-doc/front/sceneModuleList?sid=${id}`,
    // getPreviewImgList: (moduleId) => `/lx/api/category/module/preview/${moduleId}?pageNum=1&pageSize=1000`,
    getPreviewImgList: `/lx/team/directory/module/selectedModule/preview/`,
    getSelectedModules: (id) => `/lx/card/scene-doc/front/task/list?taskId=${id}`,
    getSourceList: '/lx/fodder/list',
    //删除了 getRequiredSource: (id) => `/lx/fodder/hca-pptfilesource/require/list?taskId=${id}`,
    //获取task 已经选择的素材列表
    getTaskSelectSourceList: (id) => `/lx/fodder/selected/list?taskId=${id}`,

    saveProjectIntro: '/lx/fodder/project-introduction',
    saveCustomPage: '/lx/fodder/custom-page',
    saveTask: '/lx/api/document/task/save',
    getCoverList: (fileType,docId) => `/lx/api/document/filesource/list?fileType=${fileType}&docId=${docId}`,
    publishDocument: '/lx/api/document/task/merge/file',
    getPreview: '/lx/api/document/lx-preview',
    preview: '/lx/api/document/task/preview',
    // getRecommendTags: (id) => `/lx/label/tags/recommendTags?moduleId=${id}`,
    getRecommendTags: `/lx/label/tags/recommendTags`,
    copyTask: (id) => `/lx/api/document/task/copy/${id}`,
    taskInfo: (id) => `/lx/api/document/task/getTaskInfo/${id}`,
    downloadTaskFile: (id) => `/lx/api/document/task/download/${id}`,
    documentUpload: '/lx/api/document/task/upload',
    taskPreview: (id) => `/lx/api/document/task/preview/published/${id}`,
    saveKeyword: '/lx/fodder/keyword',
    pptImg: (type,fileType) => `/lx/fodder/ppt-template/list?type=${type}&fileType=${fileType}`,
    imgTree: `/lx/fodder/image-module/tree`,
    myList: (id) => `/lx/project/personalOfficefile/list/${id}`,
    offList: (bid) => `/lx/project/publish-files/list?bid=${bid}`,
    createOrUpdate: `/lx/project/personalOfficefile/createOrUpdate`,
    uploadFiles: `/lx/file/ali/upload`,
    getProject:(bid)=> `/lx/project/personalOfficefile/info/${bid}`,
    assignmentList:(pageNum, pageSize)=>`/lx/project/userTask/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    performanceList: `/lx/api/performance/list`,
    exportList:(fileName, ids)=>`/lx/api/performance/exportSelectList?fileName=${fileName}&ids=${ids}`,
    projectList:(pageNum, pageSize)=>`/lx/api/business/all/unRelative?pageNum=${pageNum}&pageSize=${pageSize}`,
    taskList:(pageNum, pageSize)=>`/lx/project/userTask/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    getRelevance: `/lx/project/userTask/receive`,
    //任务列表的创建项目
    getCreateProject:(projectId)=>`/lx/project/userTask/businessOpptunity/${projectId}`,
    getCustomImageTags: (moduleId, taskId) => `/lx/fodder/tag-image-relation/module/tag?moduleId=${moduleId}&taskId=${taskId}&current=1&size=10000`,
    getCustomImages: `/lx/fodder/image-item/front/page`,
    getImageTags: (moduleId, taskId) => `/lx/fodder/tag-image-relation/module/tag?moduleId=${moduleId}&taskId=${taskId}&current=1&size=10000`,
    getImages: `/lx/fodder/image-item/front/page`,
    uploadProjectImage:'/lx/file/project',
    authorityName: '/lx/project/publish-files/edit/name',
    projectId:(id) => `/lx/api/business/getId/${id}`,
    getArea: `/lx/bussiness/area/list`,
    uploadDirectoryWord:`/lx/api/document/filesource/manualEntry`,
    deteleTypeData: (id, type, bid) => `/project/personalOfficefile/deleMaterial?id=${id}&type=${type}&bid=${bid}`,
    certificateExpired:(id)=>`/lx/certificate/checkReminderByFodderId?id=${id}`,

}
